import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateJobSeekerAttributesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileStructuredDataAttributesInput;
}>;


export type UpdateJobSeekerAttributesMutation = { __typename?: 'Mutation', addJobSeekerProfileStructuredDataAttributes?: { __typename: 'AddJobSeekerProfileStructuredDataAttributesPayload', certifications?: Array<{ __typename?: 'JobSeekerProfileStructuredDataCertification', id?: string | null, titleTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, uuid?: string | null } | null }> | null, licenses?: Array<{ __typename?: 'JobSeekerProfileStructuredDataLicense', id?: string | null, titleTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, label: string } | null }> | null, languages?: Array<{ __typename?: 'JobSeekerProfileStructuredDataLanguage', id?: string | null, languageTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, uuid?: string | null } | null }> | null, educations?: Array<{ __typename?: 'JobSeekerProfileStructuredDataEducation', id?: string | null, degreeTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, uuid?: string | null } | null, fieldTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', uuid?: string | null, suid?: string | null } | null }> | null, occupations?: Array<{ __typename?: 'JobSeekerProfileStructuredDataOccupation', id?: string | null, occupationTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, uuid?: string | null } | null }> | null, skills?: Array<{ __typename?: 'JobSeekerProfileStructuredDataSkill', id?: string | null, skillTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', suid?: string | null, uuid?: string | null } | null }> | null, workExperiences?: Array<{ __typename?: 'JobSeekerProfileStructuredDataWorkExperience', id?: string | null, occupationTaxonomyConcept?: { __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept', uuid?: string | null, suid?: string | null } | null }> | null } | null };


export const UpdateJobSeekerAttributesDocument = gql`
    mutation updateJobSeekerAttributes($input: AddJobSeekerProfileStructuredDataAttributesInput!) {
  addJobSeekerProfileStructuredDataAttributes(input: $input) {
    __typename
    certifications {
      titleTaxonomyConcept {
        suid
        uuid
      }
      id
    }
    licenses {
      titleTaxonomyConcept {
        suid
        label
      }
      id
    }
    languages {
      id
      languageTaxonomyConcept {
        suid
        uuid
      }
    }
    educations {
      degreeTaxonomyConcept {
        suid
        uuid
      }
      id
      fieldTaxonomyConcept {
        uuid
        suid
      }
    }
    occupations {
      id
      occupationTaxonomyConcept {
        suid
        uuid
      }
    }
    skills {
      id
      skillTaxonomyConcept {
        suid
        uuid
      }
    }
    workExperiences {
      id
      occupationTaxonomyConcept {
        uuid
        suid
      }
    }
  }
}
    `;
export type UpdateJobSeekerAttributesMutationFn = Apollo.MutationFunction<UpdateJobSeekerAttributesMutation, UpdateJobSeekerAttributesMutationVariables>;

/**
 * __useUpdateJobSeekerAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateJobSeekerAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSeekerAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSeekerAttributesMutation, { data, loading, error }] = useUpdateJobSeekerAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSeekerAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobSeekerAttributesMutation, UpdateJobSeekerAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobSeekerAttributesMutation, UpdateJobSeekerAttributesMutationVariables>(UpdateJobSeekerAttributesDocument, options);
      }
export type UpdateJobSeekerAttributesMutationHookResult = ReturnType<typeof useUpdateJobSeekerAttributesMutation>;
export type UpdateJobSeekerAttributesMutationResult = Apollo.MutationResult<UpdateJobSeekerAttributesMutation>;
export type UpdateJobSeekerAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateJobSeekerAttributesMutation, UpdateJobSeekerAttributesMutationVariables>;